import React from 'react'
import { Routes, Route } from "react-router-dom";
import Snapshot from './Pages/snapshot';
import Financial from './Pages/financial';

function AppRoutes() {
  return (
    <>
      <Routes>
          <Route path="/gorunum" element={<Snapshot />} /> 
        <Route path="/snapshot" element={<Snapshot />} />

        <Route path="/finansal" element={<Financial />} />
          <Route path="/financial" element={<Financial />} />
      </Routes>
    </>
  )
}

export default AppRoutes
